import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { BonCommande, CibleString } from 'src/app/shared/models/bonCommande';
import { BonCommandeService } from 'src/app/shared/models/bonCommandeService';
import { Service } from 'src/app/shared/models/service';
import { Prestation } from 'src/app/shared/models/prestation';
import { BonCommandeReference } from 'src/app/shared/models/bonCommandeReference';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import * as saveAs from 'file-saver';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-detail-bonCommande',
	templateUrl: './detail-bonCommande.component.html',
	styleUrls: ['./detail-bonCommande.component.scss']
})
export class DetailBonCommandeComponent implements OnInit {
	bonCommande: BonCommande;
	confirmDeleteModalRef: BsModalRef;
	detailFormationModalRef: BsModalRef;
	competences;
	isDeletable = true;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive = false;

	prestationList : Prestation[] = [];
	activitePrestationList: ActivitePrestation[] = [];

	labelBonCommandeCapitalized: string;
	labelIntervenantCapitalizedPluralized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralizedCapitalized: string;

	loading: boolean;

	isFormReadOnly = true;
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: false };

	public CibleStringEnum = CibleString;

	/**
	 * Index de pagination de la liste des formations d'un bonCommande
	 */
	currentPage: number;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	pairMissionRqEmployee: {
		missionRequest: MissionRequest;
		employeeName: string;
	}[] = [];

	listEmployee: Employee[] = [];

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = this.fb.group({
		marche: new FormControl(''),
		description: new FormControl(''),
		lot: new FormControl(''),
		descriptionLot: new FormControl(''),
		commande: new FormControl(''),
		dateDebut: new FormControl<Date>(null),
		dateFin: new FormControl<Date>(null),
		responsable: new FormControl(''),
		adjudicateur: new FormControl(''),
		adresseFacturation: new FormControl(''),
		titulaire: new FormControl(''),
		region: new FormControl(),
		references: this.fb.array([this.fb.group({
			reference: '',
			description: '',
			cible: '',
			quantite: '',
			prix: '',
			unite: ''
		})]),
		services: this.fb.array([this.fb.group({
			service: '',
			pourcentageCharge: ''
		})])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private cacheService: CacheService,
		private toastService: ToastService,
		private fb: FormBuilder
	) {}

	ngOnInit(): void {
		this.cacheService.clearCache();
		this.labelBonCommandeCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelIntervenantCapitalizedPluralized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelInterventionPluralizedCapitalized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENTION
			);

		/**
		 * Récupère le paramètre de la route
		 */
		const id = +this.route.snapshot.paramMap.get('id');
		/**
		 * Appel le back pour récupérer l'bonCommande grâce à son id
		 */
		this.facade.bonCommandeService.getBonCommandeById(id).subscribe({
			next: (bonCommande: BonCommande) => {
				this.bonCommande = bonCommande;
				this.facade.prestationService.getPrestationByBonCommande(this.bonCommande?.id).subscribe({
					next: (val) => {
						this.prestationList = val;
				
					},
				})
				this.facade.activitePrestationService.getByServiceAndRegionAndDates(this.facade.dataStorageService.getService()?.id, 
				this.facade.dataStorageService.getRegion()?.id, this.bonCommande.dateDebut, this.bonCommande.dateFin).subscribe({
					next: (activities) => {
						this.activitePrestationList = activities.filter(activity => activity.bonCommandeReference?.bonCommande?.id == this.bonCommande.id);
					}
				})
				
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/bonCommande/list']);
	}

	goEdit(bonCommande: BonCommande): void {
		const link = ['/gestion/bonCommande/edit', bonCommande.id];
		this.router.navigate(link);
	}

	delete(bonCommande: BonCommande): void {
		if (this.isDeletable) {
			this.facade.bonCommandeService
				.deleteBonCommande(bonCommande.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	onSubmit() {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			console.log(this.bonCommande);
			this.facade.bonCommandeService
				.updateBonCommande(this.bonCommande)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	calculateVolumeHorairePercent(vhTotal: number, vhUtil: number) : string{
		return (vhUtil/vhTotal * 100).toFixed(2);
	}

	calculateVolumeHoraireTotal(bonCommande: BonCommande) : number{
		let total = 0;
		bonCommande?.references?.forEach((e) => {
			total = total + e.quantite;
		})
		return total;
	}

	calculateVolumeHoraireBdcByService(vhTotal: number, bdcService: BonCommandeService) : number{
		return (vhTotal*bdcService.pourcentageCharge/100);
	}

	calculateVolumeHorairePrevByBdc() : number{
		let total = 0;
		this.prestationList?.forEach(e =>{
			total = total + e.duree;
		})
		return total;
	}

	calculateVolumeHorairePrevByService(service: Service) : number{
		let total = 0;
		this.prestationList?.forEach(e =>{
			if(service.id == e.service?.id){
				total = total + e.duree;
			}
		})
		return total;
	}

	calculateVolumeHoraireRef(bonCommandeReference: BonCommandeReference) : number{
		let total = 0;
		this.activitePrestationList.filter(e => {
			if(e.bonCommandeReference.cible == bonCommandeReference.cible){
				total = total + e.chargeTravail;
			}
		})
		return total;
	}

	calculateVolumeHoraireRefByService(service: Service, bonCommandeReference: BonCommandeReference) : number{
		let total = 0;
		
		this.activitePrestationList?.filter(e => {
			if(e.bonCommandeReference.cible == bonCommandeReference.cible
			&& e.service.id == service.id){
				total = total + e.chargeTravail;
			}
		})
		return total;
	}

	downloadSynthesis(){
		this.loading = true;
		this.facade.institutionService.downloadSynthesisByBdc(this.bonCommande.id).subscribe(	
				(blob) => {
					saveAs(blob, "syntheseBdc.docx")
					this.loading = false;
				},
				async (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				  });
	}
	
}
